import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetBoxComponent } from '../../widgets/box/box.component';
import { WidgetButtonComponent } from '../../widgets/button/button.component';
import { WidgetOptionComponent } from '../../widgets/option/option.component';
import { PipeAddress } from '../../pipes/address.pipe';
import { ModalHelper } from '../../helpers/modal.helper';
import { WalletHelper } from '../../helpers/wallet.helper';

@Component({
  selector: 'app-switch',
  templateUrl: './switch.component.html',
  imports: [
    CommonModule,
    WidgetBoxComponent,
    WidgetButtonComponent,
    WidgetOptionComponent,
    PipeAddress,
  ]
})
export class AppSwitchComponent {

  /**
   * Modal helper
   */
  modal_helper = inject(ModalHelper);

  /**
   * Wallet helper
   */
  wallet_helper = inject(WalletHelper);

  /**
   * Active account
   */
  active_account = computed(() => this.wallet_helper.active_account());

  /**
   * List of connected accounts
   */
  connected_accounts = computed(() => this.wallet_helper.connected_accounts());

  /**
   * Select account
   *
   * @param address
   */
  selectAccount(address: string) {
    this.wallet_helper.setActive(address);
    this.modal_helper.close();
  }

  /**
   * Disconnect wallet
   */
  disconnect() {
    this.wallet_helper.disconnect();
    this.modal_helper.close();
  }
}
